"use strict";

// Load React components by requiring them from "components/", for example:
//
// - "pages/index" -> `require("components/pages/index")`
// - "pages/show.Header" -> `require("components/pages/show").Header`
// - "pages/show.Body.Content" -> `require("components/pages/show").Body.Content`
//
module.exports = function (reqctx) {
  return function (className) {
    var parts = className.split(".");
    var filename = parts.shift();
    var keys = parts; // Load the module:

    var component = reqctx("./" + filename); // Then access each key:

    keys.forEach(function (k) {
      component = component[k];
    }); // support `export default`

    if (component.__esModule) {
      component = component["default"];
    }

    return component;
  };
};